export default {
      id: "i-slider-usage",
      viewBox: "0 0 21 12",
      url: __webpack_public_path__ + "img/sprite.svg#i-slider",
      toString: function () {
        return this.url;
      }
    }